// extracted by mini-css-extract-plugin
module.exports = {"OrderControls":"OrderControls_OrderControls__3xXzi"};